import AppLayout from '../layouts/AppLayout';
import NoPermission from '../components/NoPermission/NoPermissionComponent';

const NoPermissionContainer: React.FC = () => {
  return (
    <AppLayout>
      <NoPermission />
    </AppLayout>
  );
};

export default NoPermissionContainer;
